
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cluster-details/[cluster_id]",
      function () {
        return require("private-next-pages/cluster-details/[cluster_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cluster-details/[cluster_id]"])
      });
    }
  